import { faRocketLaunch } from '@awesome.me/kit-24322b77ac/icons/classic/regular';
import { Icon } from '@game/ui';
import type { JSX } from 'react';

import './Rocket.less';

export const Rocket = (): JSX.Element => {
  return (
    <div className="full-center rocket-animation">
      <Icon icon={faRocketLaunch} size="lg" />
    </div>
  );
};
